import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

export interface MicSelectDialogProps {
  open: boolean;
  onClose: () => void;
  devices: MediaDeviceInfo[];
  selectedDeviceId: string;
  onDeviceChange: (event: SelectChangeEvent<string>) => void;
}

export const MicSelectDialog: React.FC<MicSelectDialogProps> = ({
  open,
  onClose,
  devices,
  selectedDeviceId,
  onDeviceChange,
}) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="mic-dialog-title">
    <DialogTitle id="mic-dialog-title">マイクを選択</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        使用するマイクを選択してください。複数のマイクがある場合は、最適な音質のものを選んでください。
      </DialogContentText>
      <FormControl fullWidth>
        <InputLabel id="mic-select-label">マイク</InputLabel>
        <Select
          labelId="mic-select-label"
          id="mic-select"
          value={selectedDeviceId}
          label="マイク"
          onChange={onDeviceChange}
        >
          {devices.map((device) => (
            <MenuItem key={device.deviceId} value={device.deviceId}>
              {device.label || `マイク ${device.deviceId.substring(0, 5)}...`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>閉じる</Button>
    </DialogActions>
  </Dialog>
);
